<template>
  <v-layout row justify-center>
    <v-dialog persistent value="true" :max-width="maxWidth">
      <v-card>
        <v-card-text>
          <slot></slot>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="showDecline" class="btn-modal-confirm" color="primary" id="btnDecline" flat @click="$emit('onDecline')">{{ labelDecline }}</v-btn>
          <v-btn v-if="showConfirm" class="btn-modal-confirm" color="primary" id="btnConfirm" flat @click="$emit('onConfirm')">{{ labelConfirm }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: 'ModalConfirm',
  props: {
    labelConfirm: {
      type: String,
      default: 'Sim'
    },
    labelDecline: {
      type: String,
      default: 'Não'
    },
    maxWidth: {
      type: Number,
      default: 290
    },
    showDecline: {
      type: Boolean,
      default: true
    },
    showConfirm: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style scoped lang="stylus">
.btn-modal-confirm
            font-size 14px
            margin 0 10px 0 0
            text-transform none
            position relative
            height unset
            padding 5px 15px
</style>
